import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center justify-content-between mb-3" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_4 = { class: "d-flex justify-content-between align-items-center border-bottom py-3" }
const _hoisted_5 = { class: "fw-bold" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "d-flex justify-content-end mt-5" }
const _hoisted_8 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_form_field = _resolveComponent("form-field")!
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_form_field, {
        type: "text",
        modelValue: _ctx.editGarmentPropertyLayerVm.garmentLayerName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editGarmentPropertyLayerVm.garmentLayerName) = $event)),
        placeholderKey: "Garment Property Layer Name",
        placeholderValue: "Garment Property Layer Name",
        labelKey: "Garment Property Layer Name",
        labelValue: "Garment Property Layer Name"
      }, null, 8, ["modelValue"]),
      _createElementVNode("button", {
        class: "btn btn-primary",
        disabled: !_ctx.editGarmentPropertyLayerVm.garmentLayerName.trim(),
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addGarmentPropertyLayer && _ctx.addGarmentPropertyLayer(...args)))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Add",
          text: "Add"
        })
      ], 8, _hoisted_2)
    ]),
    _hoisted_3,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localValue.garmentConfigurationPropertyLayers, (layer, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: layer.garmentConfigurationLayerName
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(layer.garmentConfigurationLayerName), 1),
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: ($event: any) => (_ctx.removeGarmentPropertyLayer(index))
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "Remove",
              text: "Remove"
            })
          ], 8, _hoisted_6)
        ])
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("button", {
        class: "btn btn-tertiary",
        disabled: _ctx.localValue.garmentConfigurationPropertyLayers.length == 0,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('next')))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Continue",
          text: "Continue"
        })
      ], 8, _hoisted_8)
    ])
  ]))
}